import { defineStore } from "pinia";
import { ref, computed } from "vue";

type Breadcrumb = {
  title?: string;
  bc_icon?: string;
  route?: string;
};

const useBreadcrumbStore = defineStore("breadcrumb", () => {
  const breadcrumbs = ref<Breadcrumb[]>([]);

  const getBreadcrumbs = computed(() => breadcrumbs.value);

  const pageTitle = computed(() => {
    const last = breadcrumbs.value[breadcrumbs.value.length - 1];
    return last && last.title ? last.title : "";
  });

  const pageIcon = computed(() => {
    const last = breadcrumbs.value[breadcrumbs.value.length - 1];
    return last && last.bc_icon ? last.bc_icon : "";
  });

  function addBreadcrumb(payload: Breadcrumb | Breadcrumb[]) {
    if (Array.isArray(payload)) {
      payload.forEach((item) => breadcrumbs.value.push(item));
    } else {
      breadcrumbs.value.push(payload);
    }
  }

  function setBreadcrumb(payload: Breadcrumb[]) {
    breadcrumbs.value = payload;
  }

  function resetBreadcrumb() {
    breadcrumbs.value = [];
  }

  return {
    breadcrumbs: getBreadcrumbs,
    pageTitle,
    pageIcon,
    addBreadcrumb,
    setBreadcrumb,
    resetBreadcrumb,
  };
});

export default useBreadcrumbStore;
